import React from "react";
import { RydNumericInput } from "../widgets/data-input/RydNumericInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus
} from "@fortawesome/free-solid-svg-icons";
import RydRollHeaderGroup from "../widgets/RydRollHeaderGroup";

export function ZoomLevelSelector({
    value,
    setValue,
    referencePPQ
}: {
    value: number,
    setValue: (level: number) => void,
    referencePPQ: number
}) {
    return (
        <RydRollHeaderGroup>
            <RydNumericInput
                // label="h-z"
                value={ 0 | referencePPQ * 100 / value }
                valueDisplayPostProcessor={(v) => `${v.toFixed(2)}%`}
                setValue={(value) => {
                    if (value !== undefined) {
                        setValue(value * referencePPQ);
                    }
                }}
                min={1}
                step={1}
            />
            <button className={"flat-right"}
                onClick={() => setValue(value * 1.1)}
            >
                <FontAwesomeIcon icon={faMagnifyingGlassMinus} />
            </button>
            <button className={"flat-left"}
                disabled={value <= 1}
                onClick={() => setValue(Math.max(1, value * 0.9))}
            >
                <FontAwesomeIcon icon={faMagnifyingGlassPlus} />
            </button>
        </RydRollHeaderGroup>
    );
}